import React, { useRef } from "react";
import flecha_s from "./assets/flecha-s.png";
import "./index.css";
import { removeHTML } from "../../utils";
import { useNavigate } from "react-router-dom";
import { DEFAULT_HEADER_DATA } from "../../utils/state";
import { useTheme } from "../../contexts/ThemeContext";
import { HeaderSkeleton } from "./skeleton";
import defaultBanner from "./assets/banneras.jpg";
// import defaultBanner from "./assets/FOTO-2-scaled.jpg";
/* import defaultBanner from "./assets/img-interior25.jpg"; */
import { useConfig } from "../../contexts/config";

/* to work on */
export const HeaderCourses = ({ moodle, lang }) => {
  const theme = useTheme();
  const {config} = useConfig();
  const header = useRef(null);
  /*   const banner = React.useRef(null) */
  const [state, setState] = React.useState(DEFAULT_HEADER_DATA);
  const navigation = useNavigate();
console.log(config)

  React.useEffect(() => {
    if (moodle.courses && moodle.courses.length > 0) {
      setTimeout(() => {
        setState({
          course: moodle.courses[0],
          text: removeHTML(moodle.courses[0].summary),
        });
      }, 700);
    }
  }, [moodle]);

/*   React.useEffect(() => {
    if (moodle.courses && moodle.courses.length > 0) {
      if (header.current) {
        console.log(header.current)
        header.current.style.backgroundImage = `url(${defaultBanner})`;
         header.current.style.backgroundColor = "#9db1d1" : "#445269"; 
      }
       moodle
        .getBanner(moodle.courses[0].id)
        .then((banner) => {
          console.log(defaultBanner);
          
          // banner y color del banner se comenta y se lleva arriba el código para que no espere al getBanner y cambie de inmediato el color
          if (banner && header.current) { 
           
          } else if (!banner && header.current) {

          } 
          
        })
        .catch((err) => console.log(err)); 
    }
  }, [moodle.courses, theme.mode]); */

  /*   React.useEffect(() => {
    let item = moodle.courses[0];
    if (item?.overviewfiles?.length > 0) {
      let imgurl = moodle.getCourseImg(item);
      header.current.style.backgroundImage = `url(${imgurl})`;
    }
  }, []); */

  const handleNavigation = () => navigation(`/detailcourse/${state.course.id}`);

  return (
    <>
      {lang && (
        <div style={{ paddingTop: 80 }}>
          <header
            style={{
              padding: "20px 0",
              minHeight: 450,
              backgroundColor: theme.mode === "light" ? theme.colors.background_banner_light : theme.colors.background_banner_dark,
              backgroundBlendMode: "multiply",
              backgroundImage: `url(${defaultBanner})`,
              backgroundPosition:'97% 50%',
            }}
            className=""
            ref={header}
          >
            <div className="container mar">
              <div className="col-md-12">
                <div className="row">
                  {!state.course ? (
                    <HeaderSkeleton />
                  ) : (
                    <>
                      <div className="col-md-8">
                        <h1 className="tit-principal font-russo font-semibold bg-slate-500/20 p-2 rounded-t-md backdrop-brightness-75 w-fit" style={{ padding: 0 }}>
                          Educación STEAM - Robótica educativa{/* {state.course.fullname} */}
                        </h1>
                        <p className="text-generico"></p>
                        <p className="text-generico-res p-2 bg-slate-500/20 rounded-b-md backdrop-brightness-75 w-fit">Impulsa el pensamiento crítico y la creatividad mediante la robótica educativa en un entorno STEAM multidisciplinario.{/* {state.text} */}</p>
                        <p className="text-generico-res">
                          <button
                            type="button"
                            className="flex items-center justify-center w-2/4 tablet:w-1/4 gap-2 py-2 px-4 rounded-lg transition-transform duration-300 ease-in-out transform hover:scale-105"
                            // style={theme.styles.darkmodebtn}
                            style={{ backgroundColor: theme.mode === "light" ? theme.colors.primary_dark : theme.colors.primary_light }}
                            onClick={handleNavigation}
                          >
                            {/* <img src={flecha_s} alt="..." className="" /> */}
                            <span
                              className="font-semibold"
                              style={{ color: theme.colors.TextColorBannerBtn }}
                            >
                              {lang["Home"].course_btn}
                            </span>
                          </button>
                        </p>
                      </div>
                    </>
                  )}
                  <div className="col-md-4 pos-img"></div>
                </div>
              </div>
            </div>
          </header>
        </div>
      )}
    </>
  );
};
